module.exports = "<div  class=\"uk-animation-fade\" > <p>factory works!</p>\n\n</div>"